export default {
  code: 'Airline Code',
  nameCn: 'Chinese Name',
  nameEn: 'English Name',
  iataCode: 'IATA Code',
  icaoCode: 'ICAO Code',
  CA: 'Air China CA',
  MU: 'China Eastern MU',
  CZ: 'China Southern CZ',
  HU: 'Hainan Airlines HU',
  '3U': 'Sichuan Airlines 3U',
  CX: 'Cathay Pacific CX',
  KE: 'Korean Air KE',
  NH: 'All Nippon Airways NH',
  JL: 'Japan Airlines JL',
  LH: 'Lufthansa LH',
  AF: 'Air France AF',
  KL: 'KLM KL',
  UA: 'United Airlines UA',
  AA: 'American Airlines AA',
  DL: 'Delta Air Lines DL',
  SQ: 'Singapore Airlines SQ',
}
